import is from '@sindresorhus/is';
import clsx from 'clsx';
import type { FunctionComponent, HTMLAttributes, ReactNode } from 'react';

import { IconChevronLargeRight } from '../icons';

export type BreadcrumbItem = {
    readonly label: ReactNode | string;
    readonly onClick?: () => void;
};

export type BreadcrumbsProps = HTMLAttributes<HTMLDivElement> & {
    readonly className?: string;
    readonly items: readonly BreadcrumbItem[];
};

export const Breadcrumbs: FunctionComponent<BreadcrumbsProps> = ({ className, items, ...props }) => {
    return (
        <div className={clsx('flex items-center gap-m font-sans', className)} {...props}>
            {items.map((item, index) => {
                const isLast = index === items.length - 1;

                return (
                    // biome-ignore lint/suspicious/noArrayIndexKey: suppressed due to migration
                    <div key={index} className="flex items-center gap-m">
                        {is.function(item.onClick) && !isLast ? (
                            // biome-ignore lint/a11y/useButtonType: suppressed due to migration
                            <button
                                className="bg-transparent border-none p-0 text-xxs font-medium leading-[1rem] text-gray-700 cursor-pointer hover:text-gray-800"
                                onClick={item.onClick}
                            >
                                {item.label}
                            </button>
                        ) : (
                            <span className="text-xxs font-medium leading-[1rem] text-gray-700">{item.label}</span>
                        )}
                        {!isLast && (
                            <IconChevronLargeRight className="text-gray-500 text-sm h-[0.875rem] w-[0.875rem]" />
                        )}
                    </div>
                );
            })}
        </div>
    );
};
